import { render, staticRenderFns } from "./MarketplaceListItem.vue?vue&type=template&id=15a6d683"
import script from "./MarketplaceListItem.vue?vue&type=script&lang=js"
export * from "./MarketplaceListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports